export function transformDivisionNames(selectedDivisionIds: number[], availableDivisions: any[]): string {
  return availableDivisions
    .filter(name => selectedDivisionIds.includes(name.id))
    .map(division => division.name)
    .join(', ');
}
